/**
 * Recommendations — place context service
 *
 * Fetches the user's location context: place name and local service provider count.
 *
 * Endpoint: GET /api/recommendations
 *
 * Errors:
 *   401 — unauthenticated
 *   422 "user_has_no_location" — user has no location set
 */
import { createApiWithNewBasePath as api } from "@api";
import { IRecommendationsResponse } from "../types/recommendations.types";

export const API_PATH = "recommendations";

export const getRecommendations = () =>
  api.get<undefined, IRecommendationsResponse>(API_PATH);
